import { IPartnerBranding } from "../../domain/partner-branding.model";
import {
  PartnerBrandingActions,
  PartnerBrandingActionTypes
} from "./partner-branding.action";

export interface PartnerBrandingState {
  /** Spoke partner abbreviation from `resolve-domain`; null on a hub hostname. */
  abbreviation: string | null,
  /** Null until the branding call succeeds — every consumer falls back to the tenant-wide branding while it is null. */
  branding: IPartnerBranding | null,
  error: string | null
}

export const initialState: PartnerBrandingState = {
  abbreviation: null,
  branding: null,
  error: ""
};

function setPartnerAbbreviation(state: PartnerBrandingState = initialState, data: string | null): PartnerBrandingState {
  return {
    ...state,
    abbreviation: data || null,
    // A hostname that is not a spoke must never keep a previously-resolved
    // partner's branding around.
    branding: data ? state.branding : null
  };
}

function partnerBrandingSuccess(state: PartnerBrandingState = initialState, data: IPartnerBranding): PartnerBrandingState {
  return {
    ...state,
    branding: data || null,
    error: ""
  };
}

/**
 * Failure is a first-class, expected path here (the backend route lands with
 * SAN-387): the slice records the error and leaves `branding` null, which is
 * exactly the "fall back to tenant-wide branding" state.
 */
function partnerBrandingFault(state: PartnerBrandingState = initialState, data: string): PartnerBrandingState {
  return {
    ...state,
    branding: null,
    error: data
  };
}

export function partnerBrandingReducer(state: PartnerBrandingState = initialState, action: PartnerBrandingActions): PartnerBrandingState {
  switch (action.type) {
    case PartnerBrandingActionTypes.SetPartnerAbbreviation:
      return setPartnerAbbreviation(state, action.payload);
    case PartnerBrandingActionTypes.GetPartnerBrandingSuccess:
      return partnerBrandingSuccess(state, action.payload);
    case PartnerBrandingActionTypes.GetPartnerBrandingFault:
      return partnerBrandingFault(state, action.payload);
    default:
      return state;
  }
}
